export enum DirectControlButtonActionEnum {
    TogglePanel = 'Toggle Panel',
    Link = 'Link',
    Modal = 'Modal',
    ReplaceCar = 'Replace Car',
    ReplaceMotorcycle = 'Replace Motorcycle',
    RouterLink = 'Route',
}
